
export const state = {
  projects: null,
  packages: null,
  catalog: null,
  activeProject: {},
  commitChangesDialogVisible: false,
  uncommittedComponents: {
    loading: false,
    loaded: false,
    value: null,
    error: null
  },
  projectDeploymentDialogVisible: false,
}
